import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { FullPalette } from '@grnhse/seedling/lib/birch/colors';

type Props = {
  children: React.ReactNode;
};

const CandidateResponseLayout = (props: Props) => {
  return (
    <React.Fragment>
      <GlobalStyle />

      <Wrapper>{props.children}</Wrapper>
    </React.Fragment>
  );
};

const GlobalStyle = createGlobalStyle`
  body, html {
    padding: 0;
    margin: 0;
  }

  body {
    min-height: 100vh;
    background-color: ${FullPalette.GREY_E500};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Wrapper = styled.div`
  max-width: 544px;
  background-color: white;
  padding: 40px;
  box-sizing: border-box;
`;

export default CandidateResponseLayout;
